/* ============================================================
   Rae's toys — Theme JS
   - Variant selection (radios -> URL/SKU update)
   - Quantity stepper
   - Gallery thumb click
   - Sort dropdown redirect
   ============================================================ */

(function () {
  'use strict';

  // ----- Quantity stepper -----
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const step = parseInt(btn.dataset.step, 10);
    const wrapper = btn.closest('.qty-stepper');
    if (!wrapper) return;
    const input = wrapper.querySelector('input');
    if (!input) return;
    const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ----- Gallery thumb click -----
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.thumb').forEach((t) => t.classList.remove('active'));
    thumb.classList.add('active');
  });

  // ----- Variant radio -> URL update -----
  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.variant-option-input');
    if (!radio) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', radio.value);
    history.replaceState(null, '', url.toString());
  });

  // ----- Sort dropdown -----
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ----- Newsletter form (Shopify handles submission) -----
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.newsletter-form');
    if (!form) return;
    const btn = form.querySelector('button');
    if (btn) {
      btn.textContent = 'Subscribed ✓';
      btn.disabled = true;
    }
  });

  // ----- Mobile navigation toggle -----
  function setNavOpen(toggle, open) {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (nav) nav.setAttribute('data-nav-open', open ? 'true' : 'false');
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    setNavOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
    if (toggle) setNavOpen(toggle, false);
  });

  // Collapse the mobile menu when the viewport grows back to desktop width.
  const desktopQuery = window.matchMedia('(min-width: 641px)');
  const collapseNav = () => {
    if (!desktopQuery.matches) return;
    document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach((toggle) => setNavOpen(toggle, false));
  };
  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', collapseNav);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(collapseNav);
  }
})();
